export const form = {
  line_id: undefined, // 发布平台
  rank: undefined, // 平台关系
  real: '', // 商品编号
  name: '', // 被采访人
  title: '', // 标题
  is_top: 1, // 是否置顶
  preface: '', // 采访前言
  // cover_no: null, // 采访期数
  achievement: '', // 三月业绩
  epilogue: '', // 采访结语
  stick: ['', '', ''], // 首页展示
  content: [ { a: '', b: '' } ], // 采访人对话
  video_url: '', // 视频路径
  month_achievement: '', // 现在单月交易额
  avatar: '', // 头像
}

export const rules = {
  line_id: [
    { required: true, message: '请选择发布平台', trigger: 'change' }
  ],
  preface: [
    { required: true, message: '请输入采访前言', trigger: 'change' }
  ],
  real: [
    { required: true, message: '请输入商品编号', trigger: 'change' }
  ],
  name: [
    { required: true, message: '请输入被采访人', trigger: 'change' }
  ],
  rank: [
    { required: true, message: '请选择平台关系', trigger: 'change' }
  ],
  title: [
    { required: true, message: '请输入采访标题', trigger: 'change' }
  ],
  epilogue: [
    { required: true, message: '请输入采访结语', trigger: 'change' }
  ],
  // cover_no: [
  //   { required: true, message: '请输入采访期数', trigger: 'change' }
  // ],
  achievement: [
    { type: 'array', required: true, message: '请填写三个月业绩', trigger: 'change' }
  ],
  nickname: [
    { required: true, message: '请输入采访人', trigger: 'change' }
  ],
  month_achievement: [
    { required: true, message: '请输入现在单月交易额', trigger: 'change' }
  ]
}
